export function removeParamFromUrl(url: string, param: string): string {
  const targetUrl = new URL(url);

  targetUrl.searchParams.delete(param);

  return targetUrl.toString();
}
